import React from 'react';
import axios from 'axios';
import { servicios_grupogack_rh, registro_no_eliminado, registro_sera_eliminado } from '../../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../../Services/AuthService';
import Alertwarning from '../../../../../../../Services/Alerts/AlertWarning';

const ModalDeleteMovimientos = ({ openDelete, setOpenDelete, elementSelect, eliminar, errorTable }) => {
    const axiosEliminar = () => {
        axios.delete( `${servicios_grupogack_rh}/movimientos/${elementSelect.id}`, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:
                        eliminar( elementSelect.id );
                        break;
                    default:
                        errorTable( registro_no_eliminado );
                        break;
                }
            })
            .catch( error => {
                errorTable( registro_no_eliminado );
            })
    }
    
    return (
        <Alertwarning show={openDelete} SetopenALert={setOpenDelete} text={registro_sera_eliminado} textButtonAceptar="Aceptar" textButtonCancelar="Cancelar" action={axiosEliminar} />
    );
};

export default ModalDeleteMovimientos;